//Experience Branding

const ExperienceBranding = () => import(/* webpackChunkName: "ExperienceBranding" */ '../views/Discovery/ExperienceBranding')
const ExperienceSPBU = () => import(/* webpackChunkName: "ExperienceSPBU" */ '../views/Discovery/ExperienceBranding/SPBU')
const ExperienceSPBUDetail = () => import(/* webpackChunkName: "DigitalSPBUDetail" */ '../views/Discovery/ExperienceBranding/SPBU/Detail')
const ExperienceLifestyle = () => import(/* webpackChunkName: "ExperienceLifestyle" */ '../views/Discovery/ExperienceBranding/Lifestyle')
const ExperienceLifestyleDetail = () => import(/* webpackChunkName: "ExperienceLifestyleDetail" */ '../views/Discovery/ExperienceBranding/Lifestyle/Detail')
const ExperienceMalls = () => import(/* webpackChunkName: "ExperienceMalls" */ '../views/Discovery/ExperienceBranding/Malls')
const ExperienceMallsDetail = () => import(/* webpackChunkName: "ExperienceMallsDetail" */ '../views/Discovery/ExperienceBranding/Malls/Detail')
const ExperienceLounge = () => import(/* webpackChunkName: "ExperienceLounge" */ '../views/Discovery/ExperienceBranding/AirportLounge')
const ExperienceLoungeDetail = () => import(/* webpackChunkName: "ExperienceLoungeDetail" */ '../views/Discovery/ExperienceBranding/AirportLounge/Detail')


const ExperienceBrandingRoute = [
    {
      path: '/experience-branding',
      name: 'experiencebranding',
      component: ExperienceBranding,
      meta: { isStaffExBranding: true }
    },
    {
      path: '/experience/spbu',
      name: 'experiencespbu',
      component: ExperienceSPBU,
      meta: { isStaff: true }
    },
    {
      path: '/experience/spbu/:pub_id',
      name: 'experiencespbudetail',
      component: ExperienceSPBUDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/lifestyle/',
      name: 'experiencelifestyle',
      component: ExperienceLifestyle,
      meta: { isStaff: true }
    },
    {
      path: '/experience/lifestyle/:pub_id',
      name: 'experiencelifestyledetail',
      component: ExperienceLifestyleDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/malls/',
      name: 'experiencemalls',
      component: ExperienceMalls,
      meta: { isStaff: true }
    },
    {
      path: '/experience/malls/:pub_id',
      name: 'experiencemallsdetail',
      component: ExperienceMallsDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/airport_lounge/',
      name: 'experiencelounge',
      component: ExperienceLounge,
      meta: { isStaff: true }
    },
    {
      path: '/experience/airport_lounge/:pub_id',
      name: 'experienceloungedetail',
      component: ExperienceLoungeDetail,
      meta: { isStaff: true }
    },
]

export default ExperienceBrandingRoute;
